import React, { Component, ErrorInfo, ReactNode } from "react";
import Graphviz, { IGraphvizProps } from "graphviz-react";

interface State {
  hasError: boolean;
  error: Error | null;
}

const ErrorFallback: React.FC<{ options: IGraphvizProps }> = ({ options }) => {
  const dot =
    'digraph G { node [shape=box]; "Graph too large to be rendered" [style=filled, fillcolor=red]; }';
  return <Graphviz dot={dot} options={options} />;
};
class SafeGraphviz extends Component<IGraphvizProps, State> {
  state: State = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Graphviz rendering error caught:", error, errorInfo);
  }

  handleError = (error: any) => {
    console.error("Graphviz onError prop:", error);
    this.setState({ hasError: true, error: error as Error });
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorFallback options={this.props.options} />;
    }
    const { options, dot } = this.props;
    const finalOptions = {
      ...options,
      useWorker: false,
    };
    return <Graphviz dot={dot} options={finalOptions} />;
  }
}

export default SafeGraphviz;
